module.exports = __webpack_public_path__ + "static/img/qrcode.bc466b9e.png";